<!-- USER -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 px-2 pr-0 mb-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center" style="width: 100% !important">
                    <v-icon v-if="form.userStatus === 'APPROVED'" class="display-1 success--text icons8-checkmark-yes"></v-icon>
                    <v-icon v-if="form.userStatus === 'REJECTED'" class="display-1 warning--text icons8-high-importance"></v-icon>
                    <v-icon v-if="form.userStatus === 'PENDING'" class="display-1 grey--text icons8-circle"></v-icon>
                    <v-icon v-if="form.userStatus === 'SUSPENDED'" class="display-1 grey--text text--lighten-1 icons8-private"></v-icon>

                    <span v-if="form[collectionItem + 'Name'] === ''" class="px-2">{{ $t(`${langPath}.new`) }}</span>
                    <div v-else class="pl-2 d-inline-block text-truncate px-2">
                        <div>{{ form[collectionItem + 'Name'] }}</div>
                        <div class="caption grey--text text--darken-2">{{ form.organisation.organisationName }}</div>
                    </div>
                    <v-chip class="success" small v-if="form.swappStatus === 1">IN</v-chip>
                    <v-chip class="grey lighten-1 justify-center" small v-else>OUT</v-chip>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <!-- // Dialog to view QR Card with option to print -->
            <appbutton :block="false" @click.native="qrDialog = true" class="" label="Print QR Card" icon="icons8-name-tag"></appbutton>
            <appbutton
                :block="false"
                :label="$t(`buttons.approve`)"
                v-if="form.userStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'"
                icon="icons8-checkmark-yes"
                type="success"
                class="mr-0"
                @click.native="updateItemStatus('APPROVED')"
                showlabel="xlOnly"
            />
            <appbutton
                :block="false"
                :label="$t(`buttons.reject`)"
                v-if="form.userStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'"
                icon="icons8-high-importance"
                type="warning"
                class="mr-1"
                @click.native="updateItemStatus('REJECTED')"
                showlabel="xlOnly"
            />
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0">
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"
                                ><v-icon class="mr-2">icons8-form</v-icon>
                                <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab
                            >
                            <v-tab href="#locations" v-if="formMode !== 'New'" class="white"
                                ><v-icon class="mr-2">icons8-address</v-icon>
                                <span class="caption">{{ $t(`${langPath}.locations.tabName`) }}</span></v-tab
                            >
                            <!-- <v-tab href="#concerns"  v-if="formMode !== 'New'" class="white"><v-icon class="mr-2">icons8-comments</v-icon> <span class="caption">{{ $t(`${langPath}.concerns.tabName`) }}</span></v-tab> -->
                            <v-tab href="#notices" v-if="formMode !== 'New' && ['SA', 'SM', 'DA'].includes(GET_currentUser.userLevel)" class="white"
                                ><v-icon class="mr-2">icons8-note</v-icon>
                                <span class="caption">{{ $t(`${langPath}.notices.tabName`) }} ({{ readNotices.length }})</span></v-tab
                            >
                            <!-- <v-tab href="#qrid"  v-if="formMode !== 'New'" @click="openQrCode(form.id, form)" class="white"><v-icon class="mr-2">icons8-qr-code</v-icon> <span class="caption">{{ $t(`${langPath}.qrcard.tabName`) }}</span></v-tab> -->
                        </v-tabs>
                        <!-- // * TABS ITEMS -->
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title"
                                                    >{{ $t(`${langPath}.overview.title`)
                                                    }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text
                                                >
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>
                                                <v-divider class="my-4" />
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex px-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton
                                                    :label="$t(`buttons.undelete`)"
                                                    v-if="formMode !== 'New' && form.delete !== undefined"
                                                    icon="icons8-process"
                                                    type="purple"
                                                    class="mr-1"
                                                    @click.native="undeleteItem(form.id)"
                                                    :na="formMode !== 'View'"
                                                    :class="{ disabled: formMode !== 'View' }"
                                                    showlabel="xlOnly"
                                                />
                                                <appbutton
                                                    :label="$t(`buttons.delete`)"
                                                    v-if="formMode !== 'New' && form.delete === undefined"
                                                    icon="icons8-trash"
                                                    type="secondary"
                                                    class="mr-1"
                                                    @click.native="deleteItem(form.id)"
                                                    :na="formMode !== 'View'"
                                                    :class="{ disabled: formMode !== 'View' }"
                                                    showlabel="xlOnly"
                                                />
                                                <appbutton
                                                    :label="$t(`buttons.edit`)"
                                                    v-if="formMode !== 'New'"
                                                    icon="icons8-edit-property"
                                                    type="secondary"
                                                    class="mr-1"
                                                    @click.native="editItem()"
                                                    :na="formMode !== 'View'"
                                                    :class="{ disabled: formMode !== 'View' }"
                                                    showlabel="xlOnly"
                                                />
                                                <v-spacer />
                                                <appbutton
                                                    :label="$t(`buttons.cancel`)"
                                                    v-if="formMode === 'Edit' || formMode === 'New'"
                                                    icon="icons8-cancel"
                                                    type="grey darken-2"
                                                    class="mr-1"
                                                    @click.native="cancelItem()"
                                                    showlabel="xlOnly"
                                                />
                                                <appbutton
                                                    :label="$t(`buttons.save`)"
                                                    v-if="formMode === 'Edit' || formMode === 'New'"
                                                    icon="icons8-save"
                                                    type="info"
                                                    class="mr-0"
                                                    @click.native="validateForm()"
                                                    showlabel="xlOnly"
                                                />
                                            </v-col>
                                        </v-row>
                                        <!-- // * FORM -->
                                        <v-form ref="form" v-if="formShow">
                                            <v-row class="mt-2" no-gutters>
                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">INDUCTIONS</h5>
                                                    <v-divider class="" />
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <!-- go through each site and output the induction for each one -->
                                                            <div v-for="(site, index) in sites" :key="index">
                                                                <span>{{ site.siteName }}: </span>
                                                                <span
                                                                    v-if="computedInduction(site).inductionStatus === 'REQUIRED'"
                                                                    class="error--text font-weight-bold"
                                                                    >Required</span
                                                                >
                                                                <span
                                                                    v-if="computedInduction(site).inductionStatus === 'VALID'"
                                                                    class="success--text font-weight-bold"
                                                                    >Valid from
                                                                    {{ MIX_formatDateTime(computedInduction(site).inductionDate, 'x', 'DD/MM/YY') }}
                                                                    to
                                                                    {{
                                                                        MIX_formatDateTime(computedInduction(site).inductionRenewal, 'x', 'DD/MM/YY')
                                                                    }}</span
                                                                >
                                                                <span
                                                                    v-if="computedInduction(site).inductionStatus === 'EXPIRED'"
                                                                    class="error--text font-weight-bold"
                                                                    >Expired on
                                                                    {{
                                                                        MIX_formatDateTime(computedInduction(site).inductionDate, 'x', 'DD MMM YYYY')
                                                                    }}</span
                                                                >
                                                                <span
                                                                    v-if="computedInduction(site).inductionStatus === 'DUE'"
                                                                    class="warning--text font-weight-bold"
                                                                    >Due by
                                                                    {{
                                                                        MIX_formatDateTime(
                                                                            computedInduction(site).inductionRenewal,
                                                                            'x',
                                                                            'DD MMM YYYY'
                                                                        )
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>

                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">IMPORTANT</h5>
                                                    <v-divider class="" />

                                                    <v-row v-if="formReadOnly">
                                                        <v-col cols="3">
                                                            <span>Vulnerable Person: </span>
                                                            <span v-if="form.userVulnerablePerson" class="error--text font-weight-bold">Yes</span>
                                                            <span v-if="!form.userVulnerablePerson" class="success--text font-weight-bold">No</span>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <span>Medically Fit: </span>
                                                            <span v-if="form.userMedicallyFit" class="success--text font-weight-bold">Yes</span>
                                                            <span v-if="!form.userMedicallyFit" class="error--text font-weight-bold">No</span>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row v-if="!formReadOnly">
                                                        <v-col>
                                                            <v-select
                                                                :menu-props="{ top: false, offsetY: true }"
                                                                :attach="true"
                                                                color="black"
                                                                class="py-2"
                                                                :label="$t(`fields.userVulnerablePerson`)"
                                                                v-model="form.userVulnerablePerson"
                                                                :items="userVulnerablePersonTypes"
                                                                item-text="text"
                                                                item-value="value"
                                                                dense
                                                                filled
                                                                hide-details="auto"
                                                                required
                                                                :background-color="formBackground"
                                                                :readonly="formReadOnly"
                                                                :class="{ disabled: formReadOnly }"
                                                            >
                                                                <template v-slot:item="data">
                                                                    {{ data.item.text }}
                                                                </template>
                                                                <template v-slot:selection="data">
                                                                    {{ data.item.text }}
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                        <v-col>
                                                            <v-select
                                                                :menu-props="{ top: false, offsetY: true }"
                                                                :attach="true"
                                                                color="black"
                                                                class="py-2"
                                                                :label="$t(`fields.userMedicallyFit`)"
                                                                v-model="form.userMedicallyFit"
                                                                :items="userMedicallyFitTypes"
                                                                item-text="text"
                                                                item-value="value"
                                                                dense
                                                                filled
                                                                hide-details="auto"
                                                                required
                                                                :background-color="formBackground"
                                                                :readonly="formReadOnly"
                                                                :class="{ disabled: formReadOnly }"
                                                            >
                                                                <template v-slot:item="data">
                                                                    {{ data.item.text }}
                                                                </template>
                                                                <template v-slot:selection="data">
                                                                    {{ data.item.text }}
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>

                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">CONTACT DETAILS</h5>
                                                    <v-divider class="" />
                                                </v-col>

                                                <v-col
                                                    v-if="formMode === 'Edit' || formMode === 'New'"
                                                    class="px-2 my-2 d-flex align-center justify-center"
                                                    cols="12"
                                                    xs="12"
                                                    sm="4"
                                                    md="4"
                                                    lg="4"
                                                    xl="4"
                                                >
                                                    <v-row
                                                        class="ma-0"
                                                        v-if="uploadedFile === undefined || uploadedFile === null"
                                                        :allowedTypes="types"
                                                    >
                                                        <dragdrop
                                                            class="mt-2"
                                                            :allowedTypes="types"
                                                            :storagePath="storagePathProfilePic"
                                                            :maxWidth="'200'"
                                                        />
                                                        <v-col cols="12" class="ma-0 px-0 pb-0 pt-2">
                                                            <uploadFilesButton :storagePath="storagePathProfilePic" />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-else class="ma-0 align-center justify-center">
                                                        <v-col v-if="uploadedFile != null">
                                                            <v-img
                                                                max-width="250"
                                                                height="250"
                                                                contain
                                                                style="border-radius: 5px"
                                                                :src="uploadedFile.fileURL"
                                                            ></v-img>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col
                                                    v-else
                                                    class="px-2 pl-4 my-2 d-flex align-center justify-center"
                                                    cols="12"
                                                    xs="12"
                                                    sm="4"
                                                    md="4"
                                                    lg="4"
                                                    xl="4"
                                                >
                                                    <v-row v-if="form.profilePicFileURL != null" class="ma-0 align-center justify-center">
                                                        <v-img
                                                            max-width="250"
                                                            height="250"
                                                            contain
                                                            style="border-radius: 5px"
                                                            :src="form.profilePicFileURL"
                                                        ></v-img>
                                                    </v-row>
                                                    <v-row v-else class="justify-center">
                                                        <v-col class="mt-6 d-flex align-center justify-center" cols="12">
                                                            <v-icon size="50">icons8-image-document</v-icon>
                                                        </v-col>
                                                        <v-col class="d-flex align-center justify-center" cols="12">
                                                            <h3 class="grey--text text--darken-3">{{ $t('fields.noImage') }}</h3>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <!-- <v-col class="my-2 px-2 d-flex align-center justify-center" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-img lazy-src="/img/tfw_logo.043f9b33.png" max-height="100%" max-width="100%" style="border-radius: 5px" :src="form.profilePicFileURL"></v-img>
                                            </v-col> -->
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
                                                    <v-text-field
                                                        color="black"
                                                        class="py-2 text-capitalize"
                                                        :label="$t(`fields.name`)"
                                                        v-model="form.userName"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userName"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        color="black"
                                                        class="py-2"
                                                        :label="$t(`fields.jobTitle`)"
                                                        v-model="form.userJobTitle"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userJobTitle"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        color="black"
                                                        class="py-2"
                                                        :label="$t(`fields.email`)"
                                                        v-model="form.userEmail"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userEmail"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        color="black"
                                                        class="py-2"
                                                        :label="$t(`fields.telephone`)"
                                                        v-model="form.userTelephone"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userTelephone"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">RFID</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6">
                                                    <!-- RFID Card ID field -->
                                                    <v-text-field
                                                        color="black"
                                                        class=""
                                                        label="RFID Card ID"
                                                        v-model="form.userRFIDCardId"
                                                        filled
                                                        hide-details="auto"
                                                        :rules="rules.userRFIDCardId"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">GROUP</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="6">
                                                    <v-select
                                                        :menu-props="{ top: true, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        label="Group"
                                                        v-model="form.userGroup"
                                                        :items="userGroups"
                                                        item-text="text"
                                                        item-value="value"
                                                        dense
                                                        filled
                                                        hide-details="auto"
                                                        :background-color="formBackground"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col
                                                    class="my-2 mt-4 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="12"
                                                    md="12"
                                                    lg="12"
                                                    xl="12"
                                                    v-if="form.userGroup === 'Managers Plus' || form.userType === 'CONTRACTOR'"
                                                >
                                                    <h5 class="grey--text text--darken-1">EMERGENCY CONTACT</h5>
                                                    <v-divider class="" />
                                                </v-col>
                                                <v-col
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="6"
                                                    v-if="form.userGroup === 'Managers Plus' || form.userType === 'CONTRACTOR'"
                                                >
                                                    <v-text-field
                                                        color="black"
                                                        class=""
                                                        label="Emergency Contact Name"
                                                        v-model="form.emergencyContactName"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.emergencyContactName"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="6"
                                                    v-if="form.userGroup === 'Managers Plus' || form.userType === 'CONTRACTOR'"
                                                >
                                                    <v-text-field
                                                        color="black"
                                                        class=""
                                                        label="Emergency Contact Phone"
                                                        v-model="form.emergencyContactPhone"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.emergencyContactPhone"
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                        type="number"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    class="my-2 mt-4 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="12"
                                                    md="12"
                                                    lg="12"
                                                    xl="12"
                                                    v-if="['DA', 'SA', 'SM', 'CA'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <h5 class="grey--text text--darken-1">ORGANISATION</h5>
                                                    <v-divider class="" />
                                                </v-col>

                                                <v-col
                                                    v-if="
                                                        form.subContractorName !== '' &&
                                                            form.subContractorName !== null &&
                                                            form.subContractorName !== undefined
                                                    "
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="6"
                                                >
                                                    <v-text-field
                                                        color="black"
                                                        label="Sub Contractor"
                                                        v-model="form.subContractorName"
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="4"
                                                    md="6"
                                                    lg="6"
                                                    v-if="['DA', 'SA', 'SM', 'CA'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <v-autocomplete
                                                        :menu-props="{ top: false, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        autocomplete="donotautocomplete"
                                                        :rules="rules.organisation"
                                                        :label="$t(`fields.organisation`)"
                                                        v-model="form.organisation"
                                                        :items="organisations"
                                                        item-text="organisationName"
                                                        hide-details="auto"
                                                        required
                                                        return-object
                                                        filled
                                                        :background-color="formBackground"
                                                        dense
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">{{ data.item.organisationName }}</template>
                                                        <template v-slot:selection="data">{{ data.item.organisationName }}</template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col
                                                    v-if="form.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'"
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                                >
                                                    <v-autocomplete
                                                        :menu-props="{ top: false, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        :label="$t(`fields.site`)"
                                                        v-model="form.site"
                                                        :items="sites"
                                                        item-text="siteName"
                                                        return-object
                                                        filled
                                                        hide-details="auto"
                                                        :rules="rules.site"
                                                        required
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">
                                                            {{ data.item.siteName }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.siteName }}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col
                                                    v-if="form.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'"
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                                >
                                                    <v-autocomplete
                                                        multiple
                                                        class="mb-1"
                                                        :menu-props="{ top: false, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        label="Functions (Dept)"
                                                        v-model="form.function"
                                                        :items="functions"
                                                        return-object
                                                        filled
                                                        hide-details="auto"
                                                        :rules="rules.function"
                                                        required
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    ></v-autocomplete>
                                                    <!-- <pre>{{ form.function }}</pre> -->
                                                </v-col>
                                                <v-col
                                                    class="my-2 mt-4 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="12"
                                                    md="12"
                                                    lg="12"
                                                    xl="12"
                                                    v-if="['DA', 'SA', 'SM', 'CA', 'CM'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <h5 class="grey--text text--darken-1">SPONSOR</h5>
                                                    <v-divider class="" />
                                                    <span class="body-2 grey--text text--darken-3"
                                                        >Sponsor should either be set to this Organisation's Manager or a member of TFW Staff, If this
                                                        user is a Manager / Creator of the Organisation, then the Sponsor should be set to a member of
                                                        TFW Staff.</span
                                                    >
                                                </v-col>

                                                <v-col
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="12"
                                                    v-if="['DA', 'SA', 'SM', 'CA'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <v-autocomplete
                                                        :menu-props="{ top: false, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        autocomplete="donotautocomplete"
                                                        :rules="rules.host"
                                                        :label="$t(`fields.host`)"
                                                        v-model="form.host"
                                                        :items="hosts"
                                                        item-text="userName"
                                                        hide-details="auto"
                                                        required
                                                        return-object
                                                        filled
                                                        :background-color="formBackground"
                                                        dense
                                                        :clearable="!formReadOnly"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data"
                                                            >{{ data.item.userName }}
                                                            <span class="caption grey--text pl-2">{{ data.item.organisationName }}</span></template
                                                        >
                                                        <template v-slot:selection="data"
                                                            >{{ data.item.userName }}
                                                            <span class="caption grey--text pl-2">{{ data.item.organisationName }}</span></template
                                                        >
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col
                                                    class="my-2 mt-4 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="12"
                                                    md="12"
                                                    lg="12"
                                                    xl="12"
                                                    v-if="['DA', 'SA', 'SM', 'CA', 'CM'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <h5 class="grey--text text--darken-1">SWAPP RESPONSIBILITIES</h5>
                                                    <v-divider class="" />
                                                </v-col>

                                                <v-col
                                                    class="my-0 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    v-if="
                                                        ['DA', 'SA', 'SM', 'CA'].includes(GET_currentUser.userLevel) &&
                                                            form.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'
                                                    "
                                                >
                                                    <div class="d-flex align-center">
                                                        <v-checkbox
                                                            v-model="form.userIsFireMarshall"
                                                            :readonly="formReadOnly"
                                                            :class="{ disabled: formReadOnly }"
                                                        ></v-checkbox>
                                                        <span class="font-weight-bold darkgrey--text"
                                                            >Is Fire Marshall:
                                                            <span class="font-weight-regular"
                                                                >This User will have access to the Fire Roll Call.</span
                                                            ></span
                                                        >
                                                    </div>
                                                </v-col>

                                                <v-col
                                                    class="my-0 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    v-if="
                                                        ['DA', 'SA', 'SM', 'CA'].includes(GET_currentUser.userLevel) &&
                                                            form.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'
                                                    "
                                                >
                                                    <div class="align-center d-flex">
                                                        <v-checkbox
                                                            v-model="form.userIsFirstAider"
                                                            :readonly="formReadOnly"
                                                            :class="{ disabled: formReadOnly }"
                                                        ></v-checkbox>
                                                        <span class="font-weight-bold darkgrey--text"
                                                            >Is First Aider:
                                                            <span class="font-weight-regular"
                                                                >This User will appear on the Fire Roll Call as a First Aider</span
                                                            ></span
                                                        >
                                                    </div>
                                                </v-col>

                                                <v-col class="my-0 px-2" cols="12" xs="12">
                                                    <div class="d-flex align-center">
                                                        <v-checkbox
                                                            v-model="form.userStaffContact"
                                                            :readonly="formReadOnly"
                                                            :class="{ disabled: formReadOnly }"
                                                        ></v-checkbox>
                                                        <span class="font-weight-bold darkgrey--text"
                                                            >Is TFW Sponsor:
                                                            <span class="font-weight-regular"
                                                                >This User will be listed as a TFW Sponsor for registration of new contractors and
                                                                visitors, and on Site Access and Visitor Passes. This User needs to be a manager or
                                                                admin in order to be able to approve or reject new users.</span
                                                            ></span
                                                        >
                                                    </div>
                                                </v-col>

                                                <v-col class="my-0 px-2" cols="12" xs="12" v-show="form.site.siteName === 'Taffs Well Depot'">
                                                    <div class="d-flex align-center">
                                                        <v-checkbox
                                                            v-model="form.isTaffsWellAdminUser"
                                                            :readonly="formReadOnly"
                                                            :class="{ disabled: formReadOnly }"
                                                        ></v-checkbox>
                                                        <span class="font-weight-bold darkgrey--text"
                                                            >Is Taffs Well Induction Manager:
                                                            <span class="font-weight-regular"
                                                                >This User will receive SMS and email notifications when someone swapps into Taffs
                                                                Well without valid induction.</span
                                                            ></span
                                                        >
                                                    </div>
                                                </v-col>

                                                <!-- <v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4" v-if="form.userStaffContact && (form.userType === 'STAFF' || form.userType === 'DEVELOPER')">
                                                <v-select :menu-props="{ top: true, offsetY: true }" :attach="true" color="black"  :label="$t(`fields.contactTypes`)" v-model="form.userContactType" :items="contactTypes" item-text="text" item-value="text" dense filled hide-details="auto" required :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                    <template v-slot:item="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.text }}
                                                    </template>                                    
                                                </v-select>
                                            </v-col>                                             -->

                                                <!-- <v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" v-if="['DA','SA','SM'].includes(GET_currentUser.userLevel)">
                                                <v-autocomplete color="black"  autocomplete="donotautocomplete" :rules="rules.organisation" :label="$t(`fields.organisation`)" v-model="form.organisation" :items="organisations" hide-details="auto" required return-object filled :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">{{ data.item.organisationName }}</template>
                                                    <template v-slot:selection="data">{{ data.item.organisationName }}</template>                                                    
                                                </v-autocomplete>
                                            </v-col>    -->

                                                <v-col class="my-2 mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <h5 class="grey--text text--darken-1">PERMISSIONS</h5>
                                                    <v-divider class="" />
                                                </v-col>

                                                <v-col
                                                    class="my-2 px-2"
                                                    cols="12"
                                                    xs="12"
                                                    sm="4"
                                                    md="4"
                                                    lg="4"
                                                    xl="4"
                                                    v-if="['DA', 'SA'].includes(GET_currentUser.userLevel)"
                                                >
                                                    <v-select
                                                        :menu-props="{ top: true, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        :label="$t(`fields.type`)"
                                                        v-model="form.userType"
                                                        :items="userTypes"
                                                        item-text="text"
                                                        item-value="value"
                                                        dense
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userType"
                                                        :background-color="formBackground"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                    <v-select
                                                        :menu-props="{ top: true, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        :label="$t(`fields.userRole`)"
                                                        v-model="form.userRole"
                                                        :items="userRoles"
                                                        item-text="text"
                                                        item-value="value"
                                                        dense
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.userRole"
                                                        :background-color="formBackground"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                    <v-select
                                                        :menu-props="{ top: true, offsetY: true }"
                                                        :attach="true"
                                                        color="black"
                                                        :label="$t(`fields.status`)"
                                                        v-model="form.userStatus"
                                                        :items="userStatus"
                                                        item-text="text"
                                                        item-value="value"
                                                        dense
                                                        filled
                                                        hide-details="auto"
                                                        required
                                                        :rules="rules.status"
                                                        :background-color="formBackground"
                                                        :readonly="formReadOnly"
                                                        :class="{ disabled: formReadOnly }"
                                                    >
                                                        <template v-slot:item="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                        <template v-slot:selection="data">
                                                            {{ data.item.text }}
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <!-- <v-col><pre>{{ form }}</pre></v-col> -->
                                                <!-- <pre>{{ form }}</pre> -->
                                                <!-- INFO -->
                                                <v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="formMode !== 'New'">
                                                    <div v-if="form.hasOwnProperty('modifiedUserData')">
                                                        <h5 class="grey--text text--darken-1">{{ $t(`${langPath}.overview.info`) }}</h5>
                                                        <v-divider />
                                                        <div class="caption grey--text text--darken-1 pt-2">
                                                            <!-- // TODO -->
                                                            <strong>{{ $t(`fields.createdUserData`) }}:</strong> {{ form.userName }} -
                                                            {{ form.organisation.organisationName }} -
                                                            {{ MIX_formatDateTime(form.createdDateTime, 'x', 'HH:mm DD-MMM-YYYY') }} |
                                                            <strong>{{ $t(`fields.modifiedUserData`) }}:</strong>
                                                            {{ form.modifiedUserData.userName }} - {{ form.modifiedUserData.organisationName }} -
                                                            {{ MIX_formatDateTime(form.modifiedDateTime, 'x', 'DD-MMM-YYYY') }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- LOCATION -->
                            <v-tab-item value="locations" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title"
                                                    >{{ $t(`${langPath}.locations.title`)
                                                    }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text
                                                >
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.locations.text`) }}</app-text>
                                                <v-divider class="my-4" />
                                            </v-col>
                                            <!-- trigger update swapp status buttons -->
                                            <v-col class="pa-0 d-flex pl-1 pr-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <!-- <div v-if="modifySwappStatus !== true"> -->
                                                <appbutton
                                                    v-if="
                                                        (form.swappStatus === '0' || form.swappStatus === 0) &&
                                                            ['ADMIN', 'MANAGER'].includes(GET_currentUser.userRole) &&
                                                            $vuetify.breakpoint.mdAndUp
                                                    "
                                                    label="SWAPP IN"
                                                    @click.native="swappUser(1)"
                                                    type="secondary"
                                                    :na="modifySwappStatus === true"
                                                    :class="{ disabled: modifySwappStatus === true }"
                                                />
                                                <appbutton
                                                    v-else-if="
                                                        (form.swappStatus === '1' || form.swappStatus === 1) &&
                                                            ['ADMIN', 'MANAGER'].includes(GET_currentUser.userRole) &&
                                                            $vuetify.breakpoint.mdAndUp
                                                    "
                                                    label="SWAPP OUT"
                                                    @click.native="swappUser(0)"
                                                    type="secondary"
                                                    :na="modifySwappStatus === true"
                                                    :class="{ disabled: modifySwappStatus === true }"
                                                />
                                                <!-- </div> -->
                                                <v-spacer></v-spacer>
                                                <!-- save updated swapp status buttons -->
                                                <appbutton
                                                    v-if="modifySwappStatus === true"
                                                    label="CANCEL"
                                                    @click.native="cancelSwappStatusUpdate()"
                                                    icon="icons8-cancel"
                                                    type="grey darken-2"
                                                />
                                                <appbutton
                                                    v-if="modifySwappStatus === true"
                                                    label="UPDATE SWAPP STATUS"
                                                    @click.native="updateSwappStatus()"
                                                    icon="icons8-save"
                                                    type="info"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-2" no-gutters>
                                            <!-- last site row -->
                                            <v-col class="my-2 px-2 py-0" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <span v-if="modifySwappStatus === true && swappDirection === 0"
                                                    >To SWAPP OUT from site <strong>{{ form.lastSite.siteName }}</strong
                                                    >, location <strong>{{ form.lastLocation.locationName }}</strong> just click the Update Swapp
                                                    Status.</span
                                                >
                                                <v-text-field
                                                    color="black"
                                                    v-if="modifySwappStatus != true"
                                                    :label="$t('fields.lastSite')"
                                                    v-model="form.lastSite.siteName"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :readonly="true"
                                                    :class="{ disabled: formReadOnly }"
                                                ></v-text-field>
                                                <v-autocomplete
                                                    color="black"
                                                    v-else-if="modifySwappStatus === true && swappDirection !== 0"
                                                    @change="selectSiteLocation()"
                                                    :label="$t('fields.lastSite')"
                                                    v-model="selectedSite"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :items="availableSites"
                                                    item-text="siteName"
                                                    return-object
                                                    no-data-text="No Sites Found"
                                                    :clearable="!formReadOnly"
                                                    :readonly="formReadOnly"
                                                    :class="{ disabled: formReadOnly }"
                                                ></v-autocomplete>
                                            </v-col>
                                            <!-- last location row -->
                                            <v-col class="my-2 px-2 py-0" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-text-field
                                                    color="black"
                                                    v-if="modifySwappStatus != true"
                                                    :label="$t('fields.lastLocation')"
                                                    v-model="form.lastLocation.locationName"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :readonly="true"
                                                    :class="{ disabled: formReadOnly }"
                                                ></v-text-field>
                                                <v-autocomplete
                                                    color="black"
                                                    v-else-if="modifySwappStatus === true && swappDirection !== 0"
                                                    @change="selectLocation()"
                                                    :label="$t('fields.lastLocation')"
                                                    v-model="selectedLocation"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :items="availableLocations"
                                                    item-text="locationName"
                                                    return-object
                                                    no-data-text="No Locations Found"
                                                    :clearable="!formReadOnly"
                                                    :readonly="formReadOnly"
                                                    :class="{ disabled: formReadOnly }"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col class="my-2 px-2 py-0" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-text-field
                                                    color="black"
                                                    :label="$t('fields.swappStatus')"
                                                    v-if="form.swappStatus === 0 || form.swappStatus === '0'"
                                                    value="OUT"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :readonly="true"
                                                    :class="{ disabled: true }"
                                                ></v-text-field>
                                                <v-text-field
                                                    color="black"
                                                    :label="$t('fields.swappStatus')"
                                                    v-if="form.swappStatus === 1 || form.swappStatus === '1'"
                                                    value="IN"
                                                    filled
                                                    hide-details
                                                    :background-color="formBackground"
                                                    dense
                                                    :readonly="true"
                                                    :class="{ disabled: true }"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" class="my-4 px-2" v-if="['SA', 'DA'].includes(GET_currentUser.userLevel)">
                                        <app-text category="tab-title" class="mt-2">{{ $t(`${langPath}.locations.locationsHistory`) }}</app-text>
                                        <v-divider></v-divider>
                                        <v-data-table
                                            :headers="locationsHistoryHeaders"
                                            :items="filteredLocations"
                                            :items-per-page="5"
                                            class="elevation-1 mt-3"
                                        >
                                            <template v-slot:[`item.createdDateTime`]="{ item }">
                                                <span>{{ MIX_formatDateTime(item.createdDateTime, 'x', 'DD-MMM-YY HH:mm') }}</span>
                                            </template>
                                            <template v-slot:[`item.swappMethod`]="{ item }">
                                                <span>{{ MIX_capitalizeText(item.swappMethod) }}</span>
                                            </template>
                                            <template v-slot:[`item.swappStatus`]="{ item }">
                                                <v-chip class="success" small v-if="item.swappStatus === 1 || item.swappStatus === '1'">IN</v-chip>
                                                <v-chip class="lightgrey" small v-else>OUT</v-chip>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- // * NOTICES -->
                            <v-tab-item value="notices" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title"
                                                    >{{ $t(`${langPath}.notices.title`)
                                                    }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text
                                                >
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.notices.text`) }}</app-text>
                                                <v-divider class="my-4" />
                                            </v-col>
                                            <v-col cols="12" class="my-4 px-2">
                                                <v-data-table :headers="noticesHeaders" :items="readNotices" :items-per-page="10" class="elevation-1">
                                                    <template v-slot:[`item.noticeName`]="{ item }">
                                                        <span
                                                            v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined"
                                                            class="error--text"
                                                            ><v-icon class="error--text">icons8-trash</v-icon> {{ item.noticeName }}</span
                                                        >
                                                        <span v-else>{{ item.noticeName }}</span>
                                                    </template>
                                                    <template v-slot:[`item.createdDateTime`]="{ item }">
                                                        <span>{{ MIX_formatDateTime(item.createdDateTime, 'x', 'DD-MMM-YY HH:mm') }}</span>
                                                    </template>

                                                    <template v-slot:[`item.actions`]="{ item }">
                                                        <appbutton
                                                            sizeoverride="small"
                                                            label="VIEW"
                                                            type="secondary"
                                                            iconclass="white--text"
                                                            labelclass="white--text"
                                                            @click.native="MIX_popupNotice(item.docLink.documentId, 'View', true, true)"
                                                        />
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- QR ID -->
                            <v-tab-item value="qrid" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <v-col cols="12" class="px-2">
                                                <app-text category="tab-title">QR ID</app-text>
                                                <app-text category="tab-text"></app-text>
                                                <v-divider class="my-4" />
                                            </v-col>
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-card class="white" height="auto" width="100%" rounded>
                                                    <v-card-title class="secondary pa-1">
                                                        <v-img height="50" contain position="left" :src="require('@/assets/tfw_logo.png')" />
                                                    </v-card-title>
                                                    <v-row class="pa-4">
                                                        <v-col class="px-6" cols="5">
                                                            <qrCodeGeneratorCard />
                                                        </v-col>
                                                        <v-col class="justify-end" cols="7">
                                                            <div class="py-0 my-0 pl-3 headline">{{ form.userName }}</div>
                                                            <div class="py-0 my-0 pl-3 subtitle-1">{{ form.userJobTitle }}</div>
                                                            <div class="py-0 my-0 pl-3 subtitle-1">{{ form.userEmail }}</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <!-- DIALOGS -->
        <v-dialog v-model="qrDialog" transition="dialog-bottom-transmission" max-width="1200">
            <v-card class="grey lighten-2">
                <v-toolbar color="primary" elevation="0">
                    <app-text category="text-medium" class="white--text ml-4">Print QR Card?</app-text>
                    <v-spacer />
                    <v-btn @click="qrDialog = false" icon dark>
                        <v-icon class="icons8-multiply pr-2" color="white" />
                    </v-btn>
                </v-toolbar>

                <div id="qrCode" class="pa-4 d-flex align-center justify-center bg-grey" style="overflow: none !important">
                    <QRCard :user="form" />
                </div>

                <v-card-actions class="secondary justify-end mt-0 pa-4">
                    <!-- ENTER-ACCESS-CODE-BUTTON-->
                    <v-btn class="white" large @click="printQR">Print</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import QRCard from '@/components/QRCard.vue'
import { mapGetters, mapActions, mapState } from 'vuex' // Map the Getters from the Vuex Store
import * as htmlToImage from 'html-to-image'
export default {
    components: {
        QRCard
    },
    // * DATA
    data: () => ({
        // * PAGE DETAILS
        collection: 'users',
        collectionTitle: 'Users',
        collectionItem: 'user',
        collectionItemTitle: 'User',
        langPath: 'users.user',
        tabs: 'overview',
        // * USER UPLOAD IMAGE
        types: 'image/*',
        storagePathProfilePic: 'users-pictures',
        // * FORM RELATED
        form: {
            id: '',
            idFileId: null,
            host: {
                hostId: '',
                hostEmail: '',
                userName: ''
            },
            userStatus: '',
            userName: '',
            userEmail: '',
            userVulnerablePerson: '',
            userMedicallyFit: '',
            userTelephone: '',
            userJobTitle: '',
            userRFIDCardId: '',
            userStaffContact: false,
            userContactType: '',
            userIsHost: null,
            userIsFireMarshall: null,
            userIsFirstAider: null,
            isTaffsWellAdminUser: false,
            organisation: {
                organisationId: '',
                organisationName: '',
                organisationType: ''
            },
            profilePicFileURL: null,
            userType: '',
            userRole: '',
            site: {
                siteId: '',
                siteName: '',
                sitePostcode: '',
                siteType: ''
            },
            lastSite: {
                siteId: '',
                siteName: ''
            },
            lastLocation: {
                locationId: '',
                locationName: ''
            },
            swappStatus: null,
            swappMethod: '',
            inductionDate: '',
            subContractorName: '',
            // Added new emergency contact fields
            emergencyContactName: '',
            emergencyContactPhone: '',
            userGroup: '',
            inductions: []
        },
        rules: {},
        formMode: 'New', // Show Form in New Mode / Blank
        formReadOnly: false, // Make Form Editable
        formBackground: 'grey lighten-3',
        formShow: false,

        // * COMMENTS RELATED
        commentsTableData: [], // populated from firestore on show comments
        commentsHeaders: [
            { text: 'private', value: 'private', align: 'center', sortable: false, hidden: false, hide: false },
            { text: 'id', value: 'id', align: 'start', sortable: false, hidden: true, hide: false },
            { text: 'comment', value: 'comment', align: 'start', sortable: false, hidden: false, hide: false },
            { text: 'docLink', value: 'docLink', align: 'start', sortable: false, hidden: true, hide: false },
            { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: true },
            { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
            { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
            { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
            { text: 'delete', value: 'delete', align: 'start', sortable: false, hidden: true, hide: false },
            { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },
            { text: 'actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' }
        ],
        showDeletedComments: false, // Show Deleted Comments
        showIDComments: false,

        organisations: [],

        // * USER RELATED
        userTypes: [], // POPULATED FROM GETTER
        userRoles: [], // POPULATER FROM GETTER
        userStatus: [], // POPULATED FROM GETTER,
        userMedicallyFitTypes: [
            { text: 'Yes', value: true },
            { text: 'No', value: false }
        ],
        userVulnerablePersonTypes: [
            { text: 'Yes', value: true },
            { text: 'No', value: false }
        ],
        userGroups: [{ text: 'Managers Plus', value: 'Managers Plus' }],
        sites: [], // Populated by GET_sites
        functions: [
            'Production',
            'Engineering',
            'Shunters',
            'Maintenance Control',
            'Planning',
            'Stores',
            'Facilities',
            'Train Presentation',
            'Fleet Readiness'
        ],

        // * SWAPP STATUS RELATED
        modifySwappStatus: false, // modify swapp status
        availableLocations: [], // locations from the db
        allowLocationSelect: false, // only allow location select once a site is selected
        availableSites: [], // sites from the db
        selectedSite: null, // select site from options
        selectedLocation: null, // select location from options,
        swappDirection: 0,
        locationsHistory: [],

        // * NOTICES RELATED
        readNotices: [],

        // HOST RELATED
        hosts: [],
        inductionStatus: '',
        inductionDue: null,
        inductionRenewal: null,

        formattedInductionDate: '',

        // * QR DIALOG
        qrDialog: false
    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
            GET_openItem: 'GET_openUser', // Get Open notice Data
            GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
            GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
            GET_openUser: 'GET_openUser', // Get Open Project Data
            GET_lookupValues: 'GET_lookupValues',
            GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
            GET_help: 'GET_help',
            GET_organisations: 'GET_organisations',
            GET_sites: 'GET_sites',
            GET_currentUserData: 'GET_currentUserData',
            GET_allUsersHosts: 'GET_allUsersHosts'
        }),
        ...mapState({
            uploadedFile: state => state.upload_file_store.file
        }),
        // Computed Comments Headers
        computedCommentsHeaders() {
            var t = this
            var headers = t.commentsHeaders
            var newHeaders = []
            for (var i = 0; i < headers.length; i++) {
                var header = headers[i]
                if (header.hidden) {
                    switch (true) {
                        // Add in Cases that need to be manually controlled
                        case header.text === 'id':
                            if (t.showIDComments) {
                                newHeaders.push(header)
                            } // remove if false
                            break
                        case header.text === 'deleteUserData':
                            if (t.showDeletedComments) {
                                newHeaders.push(header)
                            } // remove if false
                            break
                        default:
                        // do nothing
                    }
                } else {
                    newHeaders.push(header)
                }
            }
            return newHeaders
        },
        // Computed Commments Table Data
        computedCommentsTableData() {
            var t = this
            var tableData = t.commentsTableData
            var tableDataList = tableData.map(e => {
                return {
                    private: e.private,
                    id: e.id,
                    comment: e.comment,
                    docLink: e.docLink,
                    createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                    createdUserData: e.createdUserData,
                    modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                    modifiedUserData: e.modifiedUserData,
                    delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                    deleteUserData: e.deleteUserData
                }
            })
            return tableDataList
        },
        // NOTICES HEADERS
        noticesHeaders() {
            return [
                { text: 'Name', value: 'notice.noticeName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Read by', value: 'createdUserData.userName', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'Read at', value: 'createdDateTime', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'Actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false }
            ]
        },
        // LOCATIONS HISTORY HEADERS
        filteredLocations() {
            var t = this
            var locations = t.MIX_sortByCreatedDateTime(t.locationsHistory)
            return locations
        },
        locationsHistoryHeaders() {
            return [
                { text: 'Status', value: 'swappStatus', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'Site', value: 'site.siteName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Location', value: 'location.locationName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Method', value: 'swappMethod', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'Swapped at', value: 'createdDateTime', align: 'center', sortable: false, hidden: false, hide: false }
            ]
        }
    },
    // * WATCH
    watch: {
        // GET CONFIRMATION RESULT
        GET_confirmBoxResult: {
            handler: async function() {
                var t = this
                if (t.GET_confirmBoxResult.data.collection === t.collection) {
                    if (t.GET_confirmBoxResult.data.result === 'YES') {
                        var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id)
                        if (deleteResult.code === 1) {
                            t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null)
                            t.refreshItemView()
                        } else {
                            t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error)
                        }
                    }
                } else if (t.GET_confirmBoxResult.data.collection === 'concerns') {
                    if (t.GET_confirmBoxResult.data.result === 'YES') {
                        var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id)
                        if (deleteResult.code === 1) {
                            t.MIX_alert(1, 'Concern Deleted', deleteResult.data, null)
                        } else {
                            t.MIX_alert(-1, 'Error Deleting Concern', null, deleteResult.error)
                        }
                    }
                } else if (t.GET_confirmBoxResult.data.collection === 'comments') {
                    if (t.GET_confirmBoxResult.data.result === 'YES') {
                        var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id)
                        if (deleteResult.code === 1) {
                            t.MIX_alert(1, 'Comment Deleted', deleteResult.data, null)
                        } else {
                            t.MIX_alert(-1, 'Error Deleting Comment', null, deleteResult.error)
                        }
                    }
                } else {
                    // Do nothing
                }
            },
            deep: true
        },
        GET_datePickerResult: {
            // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
            handler() {
                switch (this.GET_datePickerResult.field) {
                    case 'inductionDate':
                        this.form.inductionDate = this.GET_datePickerResult.value // Update the Form Start Date
                        this.formattedInductionDate = this.MIX_formatDateTime(this.form.inductionDate, 'x', 'DD-MMM-YYYY') // Update the Formatted Project Start Date
                        break
                    // case 'projectEndDate':
                    //     this.form.endDate = this.GET_datePickerResult.value; // Update the Form End Date
                    //     this.formattedProjectEndDate = this.MIX_formatDateTime(this.form.endDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project End Date
                    //     break;
                    default:
                        //do nothing
                        break
                }
            },
            deep: true
        },
        GET_panelLayout: {
            handler() {
                let t = this
                if (t.GET_panelLayout.show === false) {
                    for (var i = 0; i < t.headers.length; i++) {
                        if (t.headers[i].hide === true) {
                            t.headers[i].hidden = false
                        }
                    }
                } else {
                    for (var i = 0; i < t.headers.length; i++) {
                        if (t.headers[i].hide === true) {
                            t.headers[i].hidden = true
                        }
                    }
                }
            },
            deep: true
        },
        // watch for changes to the file in the store
        uploadedFile: {
            handler: function() {
                this.uploadedFile
            },
            deep: true
        },
        // watch for site changes to reset Taffs Well admin flag
        'form.site': {
            handler: function(newSite) {
                if (newSite && newSite.siteName !== 'Taffs Well Depot') {
                    this.form.isTaffsWellAdminUser = false
                }
            },
            deep: true
        }
    },
    // * METHODS
    methods: {
        ...mapActions({ ACT_openItem: 'ACT_openUser', ACT_openUser: 'ACT_openUser' }),
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            var t = this
            var breadcrumbs = []
            breadcrumbs.push({ name: `${t.collectionTitle}`, path: `/${t.collection}` }) // Set the Main Path
            if (t.GET_openItem.process === 'New') {
                breadcrumbs.push({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}` }) // Set a Secondary Path
            } else {
                breadcrumbs.push({
                    name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`,
                    path: `/${t.collection}/${this.GET_openItem.data.id}`
                }) // Set a Secondary Path
            }
            this.MIX_breadcrumbs(breadcrumbs)
        },
        computedInduction(site) {
            let t = this
            var validInductions = []
            var requiredInductions = []
            var expiredInductions = []
            var dueInductions = []
            var currentDate = t.$moment().format('x')
            var induction = null

            if (t.form.inductions && t.form.inductions.length > 0) {
                var siteInductions = t.form.inductions.filter(function(induction) {
                    return induction.site === site.siteId
                })
                siteInductions = t.$sortBy(siteInductions, 'date').reverse()
                siteInductions = siteInductions.slice(0, 1)

                if (siteInductions && siteInductions.length > 0) {
                    induction = siteInductions[0]
                }
            }

            if (induction) {
                var inductionDate2Y = t
                    .$moment(induction.date, 'x')
                    .add(2, 'years')
                    .format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                let inductionStatus
                switch (true) {
                    case inductionDue > 0:
                        inductionStatus = 'EXPIRED'
                        break
                    case inductionDue > -90 && inductionDue <= 0:
                        inductionStatus = 'DUE'
                        break
                    default:
                        inductionStatus = 'VALID'
                        break
                }

                return {
                    siteId: site.siteId,
                    siteName: site.siteName,
                    inductionStatus: inductionStatus,
                    inductionDate: induction.date,
                    inductionDue: inductionDue,
                    inductionRenewal: inductionDate2Y
                }
            } else if (site.siteId == 'aeKJ3GotwdOBVoA1f2oY' && t.form.inductionDate && t.form.inductionDate !== '') {
                var userInduction = t.form.inductionDate
                var inductionDate2Y = t
                    .$moment(userInduction, 'x')
                    .add(2, 'years')
                    .format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                let inductionStatus
                switch (true) {
                    case inductionDue > 0:
                        inductionStatus = 'EXPIRED'
                        break
                    case inductionDue > -90 && inductionDue <= 0:
                        inductionStatus = 'DUE'
                        break
                    default:
                        inductionStatus = 'VALID'
                        break
                }

                return {
                    siteId: site.siteId,
                    siteName: site.siteName,
                    inductionStatus: inductionStatus,
                    inductionDate: userInduction,
                    inductionDue: inductionDue,
                    inductionRenewal: inductionDate2Y
                }
            } else {
                return {
                    siteId: site.siteId,
                    siteName: site.siteName,
                    inductionStatus: 'REQUIRED',
                    inductionDate: null,
                    inductionDue: null,
                    inductionRenewal: null
                }
            }
        },
        // OPEN ITEM
        openItem: async function() {
            var t = this
            var openItem = await t.GET_openItem // Get Open Item Data
            switch (openItem.process) {
                case 'New':
                    t.formMode = 'New' // Show Form in New Mode
                    t.formReadOnly = false // Make Form Editable
                    t.formBackground = 'white' // Change Background Colour of Form
                    break
                case 'View':
                    var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                    t.form = item.data // Update the Form with the Open Item details
                    t.formMode = 'View' // Show Form in View Mode
                    t.formReadOnly = true // Make Form Read Only
                    t.formBackground = 'grey lighten-3' // Change Background Colour of Form
                    break
                case 'Edit':
                    var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                    t.form = item.data // Update the Form with the Open Item details
                    t.formMode = 'Edit' // Show Form in Edit Mode
                    t.formReadOnly = false // Make Form Editable
                    t.formBackground = 'white' // Change Background Colour of Form
                    break
            }
            return
        },
        // EDIT ITEM
        editItem() {
            var t = this
            t.formMode = 'Edit'
            t.formReadOnly = false
            t.formBackground = 'white'
        },
        // CANCEL ITEM
        cancelItem() {
            var t = this
            t.formMode = 'View'
            t.formReadOnly = true
            t.formBackground = 'grey lighten-3'
            //t.removeUploadedDocument();
            t.refreshItemView()
            t.closeRightPanel()
        },
        closeRightPanel() {
            this.updateBreadcrumbs()
            this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' })
        },
        // SAVE ITEM
        saveItem: async function() {
            var t = this
            if (t.form.id === undefined) {
                t.form.id = t.MIX_generateId() // if new then generate new id
            }
            // console.log("form = " + JSON.stringify(t.form, null, 2))
            // console.log("user = " + JSON.stringify(t.GET_currentUserData, null, 2))
            // if(t.uploadedFile != null){
            //     t.form.fileData.fileURL = t.uploadedFile.fileURL;
            //     t.form.fileData.fileType = t.uploadedFile.fileType;
            //     t.form.fileData.fileName = t.uploadedFile.fileName;
            // }
            if (this.uploadedFile != null) {
                this.form.profilePicFileURL = this.uploadedFile.fileURL
            }
            var createDocumentResult = await t.MIX_createDocument(t.collection, t.form) // Create Document Within Firestore based on Form
            if (createDocumentResult.code === 1) {
                t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null) // Send Success Alert to Item
                t.formMode = 'View' // Change Form Mode
                t.formReadOnly = true // Set Form to Read Only
                t.formBackground = 'grey lighten-3'
                t.refreshItemView()
                t.removeUploadedDocument()
            } else {
                t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null) // Send Error Alert to Item
            }
        },
        // * VALIDATION RULES
        validateForm() {
            let t = this
            t.rules = {
                userName: [v => !!v || 'User Name is required', v => (v && v.length < 255) || 'Name must be less than 255 characters'],
                userJobTitle: [v => !!v || 'User Job Title Required'],
                userEmail: [v => !!v || 'User Email Required'],
                userTelephone: [v => !!v || 'User Telephone Required'],
                userType: [v => !!v || 'Type Required'],
                userRole: [v => !!v || 'Role Required'],
                status: [v => !!v || 'Status Required'],
                id: [v => !!v || 'ID Required'],
                userVulnerablePerson: [v => !!v || 'Vulnerable Person  Required'],
                userMedicallyFit: [v => !!v || 'Medically Fit  Required'],
                organisation: [v => !!v || 'Organisation Required']
                // emergencyContactName: [v => !!v || 'Emergency Contact Name is required'],
                // emergencyContactPhone: [v => !!v || 'Emergency Contact Phone is required']
            }
            //let the DOM update
            t.$nextTick(() => {
                //manually trigger Vuetify validation
                if (t.$refs.form.validate()) {
                    //t.MIX_alert(1, "Passed validation.", null, null);
                    //it's valid, do work
                    // t.MIX_confirmBox (
                    // 	{
                    // 		show: true,
                    // 		collection: t.collection,
                    // 		id: t.form.id,
                    // 		title: `New Project`,
                    // 		description: `Please confirm that all the information given is correct`,
                    // 		width: '300',
                    // 		height: '300',
                    // 		trueButtonText: 'Yes',
                    // 		trueButtonValue: 'YES',
                    // 		falseButtonText: 'No',
                    // 		falseButtonValue: 'NO',
                    //   	}
                    // )
                    this.saveItem()
                } else {
                    t.MIX_alert(-1, 'Please fill out all the fields', null, null)
                }

                //if not valid, errors will be automatically displayed
            })
        },
        // UPDATE ITEM STATUS
        updateItemStatus: async function(status) {
            var t = this
            // if approved, send email notification to let user know and let them knwo to complete induction
            if (status == 'APPROVED') {
                t.sendApprovedNotification()
            }
            var updateResult = await t.MIX_updateDocumentFieldsById(t.collection, t.form.id, { [t.collectionItem + 'Status']: status })
            if (updateResult.code === 1) {
                t.MIX_alert(1, 'Status Updated', updateResult.data, null)
                t.refreshItemView()
            } else {
                t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error)
            }
        },
        sendApprovedNotification() {
            var t = this

            // var user = t.form;

            // var notification = {}

            // notification.type = '',
            // notification.name = '',
            // notification.priority = 'info',
            // notification.description = 'Your account has been Approved',
            // notification.category = '',
            // notification.linkText = '',
            // notification.link = '',
            // notification.read = '',
            // notification.recipient = '',
            // notification.sender = '';

            // var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
        },
        // REMOVE UPLOADED DOCUMENT
        removeUploadedDocument() {
            this.$store.commit('upload_file_store/setFile', null)
        },
        // REFRESH ITEM VIEW
        refreshItemView: async function() {
            var t = this
            var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
            var payload = {}
            payload.process = 'View'
            payload.popup = false
            payload.data = itemResult.data
            t.ACT_openItem(payload)
            t.openItem()
        },
        // DELETE ITEM METHOD
        deleteItem: function(id) {
            var t = this
            t.MIX_confirmBox({
                show: true,
                collection: t.collection,
                id: id,
                title: `Delete ${t.collectionItemTitle}`,
                description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`,
                width: '400',
                height: '200',
                trueButtonText: 'Yes',
                trueButtonValue: 'YES',
                falseButtonText: 'No',
                falseButtonValue: 'NO'
            })
        },
        // UNDELETE ITEM METHOD
        undeleteItem: async function(id) {
            var t = this
            var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
            if (undeleteResult.code === 1) {
                t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null)
            } else {
                t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error)
                //console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
            }
            t.refreshItemView()
        },
        // * QR ID RELATED METHODS
        openQrCode(id, item) {
            this.MIX_generateCode(false, id, 200, 'H', 'qrcode', 'canvas', '#ffffff', '#000000', true, item.userName)
        },
        // * USER RELATED METHODS
        // Change Status
        changeStatus: async function(status) {
            var updateDocumentResult = await this.MIX_updateDocumentFieldsById('users', this.form.id, { userStatus: status })
            if (updateDocumentResult.code === 1) {
                this.MIX_alert(1, 'Status Updated', updateDocumentResult.data, null)
                var user = await this.MIX_readDocumentById('users', this.form.id)
                this.ACT_openUser(user.data)
            } else {
                this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult.error)
            }
        },
        swappUser(direction) {
            this.getAvailableSites()
            this.modifySwappStatus = true
            this.swappDirection = direction
            this.form.swappStatus = direction
            this.form.swappedTime = this.$moment().format('X')
            this.formReadOnly = false
        },
        selectSiteLocation() {
            //console.log('HERE::::: ' + this.selectedSite)
            if (this.selectedSite != null) {
                this.form.lastSite.siteId = this.selectedSite.id
                this.form.lastSite.siteName = this.selectedSite.siteName
            }
            this.getAvailableLocations()
            this.allowLocationSelect = true
        },
        selectLocation() {
            if (this.selectedLocation != null) {
                this.form.lastLocation.locationId = this.selectedLocation.id
                this.form.lastLocation.locationName = this.selectedLocation.locationName
            }
        },
        async getAvailableSites() {
            // TODO only show the last value if SWAPP value is OUT
            var sitesResult = await this.MIX_readDocuments('sites')
            if (sitesResult.code === 1) {
                this.availableSites = sitesResult.data
            } else {
                this.availableSites = []
                //console.log('sitesResult : ' + sitesResult.message)
            }
        },
        async updateSwappStatus() {
            this.form.swappMethod = 'MANUAL'
            var updateDocumentResult = await this.MIX_updateDocument('users', this.form)
            if (updateDocumentResult.code === 1) {
                this.modifySwappStatus = false
                this.MIX_alert(1, 'Swapp Status Updated', updateDocumentResult.data, null)
                var user = await this.MIX_readDocumentById('users', this.form.id)
                this.ACT_openUser(user.data)
            } else {
                this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult.error)
            }
        },
        cancelSwappStatusUpdate() {
            if (this.swappDirection === 0) {
                this.swappDirection = 1
                this.form.swappStatus = 1
            } else {
                this.swappDirection = 0
                this.form.swappStatus = 0
            }
            this.modifySwappStatus = false
        },
        async getAvailableLocations() {
            var locationsResult = await await this.MIX_readDocumentsByKeyValue('locations', 'site.id', this.selectedSite.id)
            if (locationsResult.code === 1) {
                this.availableLocations = locationsResult.data
            } else {
                this.availableLocations = []
                //console.log('locationsResult : ' + locationsResult.message)
            }
        },
        getLocationsHistory() {
            var t = this
            t.$firebase.db
                .collection('swappLogs')
                .where('swappedUser', '==', t.form.id)
                .onSnapshot(function(querySnapshot) {
                    t.locationsHistory = []
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            t.locationsHistory.push(document)
                            //console.log('here: ' + t.readNotices.length)
                        } else {
                            // Do not Show Notice
                        }
                    })
                })
        },
        // GET READ NOTICES
        getAlreadyReadNotices() {
            var t = this
            t.$firebase.db
                .collection('readNoticesLogs')
                .where('readBy', '==', t.form.id)
                .onSnapshot(function(querySnapshot) {
                    t.readNotices = []
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            t.readNotices.push(document)
                            //console.log('here: ' + t.readNotices.length)
                        } else {
                            // Do not Show Notice
                        }
                    })
                })
        },
        currentUsersInduction() {
            var t = this
            if (t.form.inductionDate !== '') {
                var inductionDate2Y = t
                    .$moment(t.form.inductionDate, 'x')
                    .add(2, 'years')
                    .format('x')
                var currentDate = t.$moment().format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')
                t.inductionRenewal = inductionDate2Y
                t.inductionDue = inductionDue

                switch (true) {
                    case inductionDue > 0:
                        t.inductionStatus = 'EXPIRED'
                        break
                    case inductionDue > -90 && inductionDue < 0:
                        t.inductionStatus = 'DUE'
                        break
                    default:
                        t.inductionStatus = 'VALID'
                        break
                }
            } else {
                t.inductionStatus = 'REQUIRED'
                //console.log('inductionStatus = ' + t.inductionStatus)
            }
        },
        getSponsors: async function() {
            let t = this
            //var hostsResult = await t.MIX_readDocumentsByKeyValue('users', 'userIsHost', true);
            var hostsResult = t.GET_allUsersHosts
            let hostsData = t.$filter(hostsResult, host => {
                return host.organisationId === 'UshqEqj4OeCGI4JHMjUk' || host.organisationId === t.form.organisation.organisationId
            })
            hostsData = t.$sortBy(hostsData, 'userName')
            t.hosts = hostsData.map(user => {
                return {
                    userId: user.id,
                    userName: user.userName,
                    userEmail: user.userEmail,
                    organisationId: user.organisationId,
                    organisationName: user.organisationName
                }
            })
        },
        printQR() {
            var t = this
            // Capture the card rather than its #qrCode wrapper, so the PNG is exactly card sized and fills the card when printed
            // pixelRatio must stay 1: html-to-image 1.3.20 enlarges the canvas by it without scaling the card, leaving the card in the top left corner
            htmlToImage.toBlob(document.getElementById('qrCode').querySelector('.v-card'), { pixelRatio: 1 }).then(function(blob) {
                window.saveAs(blob, t.form.userName + '.png')
            })

            // var divContents = document.getElementById("qrCode").innerHTML;
            // var a = window.open('', '', 'height=500, width=500');
            // a.document.write('<html>');
            // a.document.write('<body >');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
            // a.print();

            // var printContents = document.getElementById('qrCode').innerHTML;
            // var originalContents = document.body.innerHTML;

            // document.body.innerHTML = printContents;

            // window.print();

            // document.body.innerHTML = originalContents;
        }
    },
    async mounted() {
        var t = this
        t.formShow = false
        // * LOOKUP RELATED MOUNTED
        await t.MIX_lookupValues() // LOAD LOOKUP VALUES
        await t.MIX_allUsersHosts() // LOAD USERS HOSTS
        t.userTypes = await t.GET_lookupValues('USERTYPES')
        t.userRoles = await t.GET_lookupValues('USERROLES')
        t.userStatus = await t.GET_lookupValues('USERSTATUS')
        t.contactTypes = await t.GET_lookupValues('CONTACTTYPES')

        // * SITES
        t.sites = t.GET_sites // STORE SITES IN LOCAL ARRAY
        //console.log('hosts' + JSON.stringify(t.hosts, null, 2))

        // * ORGANISATIONS
        // t.organisations = t.GET_organisations;
        t.organisations = t.$sortBy(t.GET_organisations, 'organisationName') // STORE SITES IN LOCAL ARRAY
        //console.log("organisations = " + JSON.stringify(t.organisations, null, 2))
        // * ITEM RELATED MOUNTED
        var openItem = await t.GET_openItem // Get Open Project Data
        // console.log("item = " + JSON.stringify(t.GET_currentUserData, null, 2))
        t.formMode = openItem.process // Show Form in View Mode
        //console.log('openItem' + JSON.stringify(openItem, null, 2))
        if (openItem.process === 'New') {
            t.formReadOnly = false // Make Form Editable
            t.formBackground = 'white'
            // * Get Sponsors
            t.getSponsors()
        } else {
            t.formShow = true
            t.form = openItem.data // Update the Form with the Open Project details
            t.formReadOnly = true
            t.formBackground = 'grey lighten-3'
            t.formattedInductionDate = t.MIX_formatDateTime(t.form.inductionDate, 'x', 'DD-MMM-YYYY') // Update the Formatted Project Start Date

            var formFunction = t.form.function
            if (!Array.isArray(formFunction)) {
                t.form.function = []
                t.form.function.push(formFunction)
            }

            // * Get Sponsors
            t.getSponsors()
        }
        if (openItem.popup === false) {
            t.updateBreadcrumbs()
        } // Update Breadcrumbs in Title
        t.getAlreadyReadNotices()
        t.getLocationsHistory()
        t.currentUsersInduction()
    }
}
</script>

<style scoped>
.disabled {
    pointer-events: none;
    cursor: not-allowed;
}
.disabled >>> .v-input__slot::before {
    border-style: none !important;
}
</style>
